import { User } from '../../shared/models';

export class SetUser {
  static readonly type = '[USER] Set User';
  constructor(public user: User) {}
}
